import React from 'react';
import classnames from 'classnames';
import { Marker } from 'react-map-gl';
import { makeStyles } from '@material-ui/core';
import { defaultIcons } from 'data/defaultProducts';

const ICON_SIZE = 32;

const iconStyle = makeStyles({
  icon: {
    width: ICON_SIZE,
    height: ICON_SIZE,
    cursor: 'pointer',
    transform: `translate(-${ICON_SIZE * 0.5}px,-${ICON_SIZE * 0.5}px)`,
    '&:hover': {
      width: ICON_SIZE + 8,
      height: ICON_SIZE + 8,
      transform: `translate(-${(ICON_SIZE + 8) * 0.5}px,-${(ICON_SIZE + 8) *
        0.5}px)`,
    },
  },
  iconSelected: {
    width: ICON_SIZE + 16,
    height: ICON_SIZE + 16,
    transform: `translate(-${(ICON_SIZE + 16) * 0.5}px,-${(ICON_SIZE + 16) *
      0.5}px)`,
  },
});

const WaterLevelLayer = ({ setDialogue }) => {
  const style = iconStyle();

  return defaultIcons.map((country, i) => (
    <Marker key={i} longitude={country.latLng[0]} latitude={country.latLng[1]}>
      <img
        src={country.icon}
        onClick={() => setDialogue({ ...country })}
        className={classnames({
          [style.icon]: true,
          [style.iconSelected]: defaultIcons[i].active,
        })}
        alt="marker icon"
      />
    </Marker>
  ));
};

export default WaterLevelLayer;
